import { render, staticRenderFns } from "./sum-pie-chart.vue?vue&type=template&id=9a45d932&scoped=true&"
import script from "./sum-pie-chart.vue?vue&type=script&lang=js&"
export * from "./sum-pie-chart.vue?vue&type=script&lang=js&"
import style0 from "./sum-pie-chart.vue?vue&type=style&index=0&id=9a45d932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a45d932",
  null
  
)

export default component.exports